var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credits"},[_c('p',_vm._l((_vm.credits),function(item,index){return _c('span',[_vm._v(_vm._s(item.title)+": "),_c('strong',[_vm._v(_vm._s(item.author))]),_vm._v("  ")])}))])}
var staticRenderFns = []

export { render, staticRenderFns }